import React, { Component } from 'react'
import configs from '../../../configs.json'
import ApiService from "../../services/api"
import Loading from '../loading/loading'

const apiservice = new ApiService()

class Subscribe extends Component {
    constructor(props) {
        super(props)
        this.state = {
            redirect : null
        }
    }

    getAuth() {
        const user  = localStorage.getItem('user')
        const token = localStorage.getItem('token')

        const req = new FormData()
        req.append('user', user)
        req.append('token', token)

        apiservice.hasAuth(req).then((res) => {
            const auth = res.auth
            switch (auth) {
                case 'Visitor':
                    this.setState({ redirect : true })
                    break
                case 'User':
                    this.setState({ redirect : false })
                    break
                case 'Client':
                    this.setState({ redirect : true })
                    break
                default:
                    this.setState({ redirect : true })
            }
        })
    }

    componentDidMount() {
        this.getAuth()
    }

    renderPlanAction(p) {
        if (p.id === null) {
            return (
                <a
                    className="btn waves-effect waves-light"
                    style={{backgroundColor: configs.colors.secondary}}
                    href={`mailto:${configs.contact.email}?subject=Plano Customizado Alira`}
                >
                    Fale Conosco
                </a>
            )
        }
        return (
            <form action={`${process.env.REACT_APP_API_URL}/subscriptions/subscription/`} method="POST">
                <input type="hidden" name="price_id" value={p.id} />
                <button
                    className="btn waves-effect waves-light"
                    style={{backgroundColor: configs.colors.primary}}
                    type="submit"
                >
                    R${p.price} / Mês
                </button>
            </form>
        )
    }

    render() {
        if (this.state.redirect === false) {
            return (
                <div className='container' id='subscription'>
                    <div className='row section-row'>
                        <h3 style={{color: configs.colors.primary}}>Inscreva-se</h3>
                        <h6 style={{color: configs.colors.dark}}>Escolha o plano que mais combina com você</h6>
                        <br></br>
                        <div className='subscription'>
                            {configs.plans.map((p) =>
                            <div className='starter-div col s12 m3' key={p.name}>
                                <div className='card' style={{backgroundColor: configs.colors.offwhite}}>
                                    <div className="card-title" style={{color: configs.colors.primary, borderBottom: '1px solid ' + configs.colors.secondary}}>
                                        <h4>Plano {p.name}</h4>
                                    </div>
                                    <div className="card-content" style={{padding: '20px 10px 20px 30px'}}>
                                        <p style={{fontWeight: 'bold', color: configs.colors.secondary}}>
                                            {p.minutes !== null ? `${p.minutes} min / mês` : 'Ilimitado'}
                                        </p>
                                        <ul style={{textAlign: 'left', listStyleType: 'initial'}}>
                                            {configs.services.map((s) =>
                                                <li key={`${p.name}-${s.name}`}>{s.name}</li>
                                            )}
                                        </ul>
                                        {p.overage && p.minutes !== null && (
                                            <p style={{fontSize: '0.85rem', marginTop: '8px', color: '#888'}}>
                                                Excedente: R$0,25/min
                                            </p>
                                        )}
                                    </div>
                                    <div className="card-action" style={{borderTop: '1px solid ' + configs.colors.secondary}}>
                                        {this.renderPlanAction(p)}
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                        <br></br>
                    </div>
                </div>
            )
        }
        if (this.state.redirect === true) {
            window.location.replace(process.env.REACT_APP_URL)
        }
        if (this.state.redirect === null) {
            return (
                <Loading/>
            )
        }
    }
}

export default Subscribe